import {useState} from 'react'
import {useTranslation} from 'react-i18next'

import useChangeLanguage from '@progyny/components/Navigation/useChangeLanguage'
import {useMeQuery} from '@progyny/generated/graphql'

const useMobileLanguagePicker = () => {
  const {i18n} = useTranslation()
  const {data} = useMeQuery()
  const {changeLanguage} = useChangeLanguage()
  const [languageLoading, setLanguageLoading] = useState(false)
  const [isPickerOpen, setPickerOpen] = useState(false)

  const languageName = data?.languages?.find(
    (lang) => lang?.code === i18n.language
  )?.name

  const handleSelect = async (code: string) => {
    setPickerOpen(false)
    setLanguageLoading(true)
    try {
      await changeLanguage(code)
    } catch {
      // Keep current language when translations fail to load
    } finally {
      setLanguageLoading(false)
    }
  }

  return {
    languages: data?.languages,
    language: i18n.language,
    languageName,
    languageLoading,
    isPickerOpen,
    openPicker: () => setPickerOpen(true),
    closePicker: () => setPickerOpen(false),
    handleSelect,
  }
}

export default useMobileLanguagePicker
